import { Modal, useModals } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'
import { SourceMaterialAnalysis } from 'types'
import { parseSourceBrief } from './parseSourceBrief'
import Styles from './AnalysisSummaryModal.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Input } from 'almanac-ui/TextInputField/Input'

interface Props {
  name: string
  analysis: SourceMaterialAnalysis
}

interface SectionProps {
  label: string
  children: React.ReactNode
}

const Section = ({ label, children }: SectionProps) => (
  <div className={Styles.section}>
    <Heading level={5}>{label}</Heading>
    {children}
  </div>
)

export const AnalysisSummaryModal = ({ name, analysis }: Props) => {
  const { closeModal } = useModals()
  const brief = analysis.analysis ? parseSourceBrief(analysis.analysis) : null

  return (
    <Modal.Root size="md" onClose={closeModal}>
      <Modal.Header title={name} />
      <Modal.Content>
        <div className={Styles.content}>
          {brief ? (
            <>
              {brief.posts && (
                <Section label="Posts">
                  <Input value={brief.posts} name="posts" isTextarea readOnly className={Styles.input} />
                </Section>
              )}

              {brief.themes && (
                <Section label="Themes">
                  <Input value={brief.themes} name="themes" isTextarea readOnly className={Styles.input} />
                </Section>
              )}

              {brief.keyInsights.length > 0 && (
                <Section label="Key insights">
                  <Input
                    value={brief.keyInsights.join('\n\n')}
                    name="insight"
                    isTextarea
                    readOnly
                    className={Styles.input}
                  />
                </Section>
              )}

              {brief.audience && (
                <Section label="Audience">
                  <Input value={brief.audience} name="audience" isTextarea readOnly className={Styles.input} />
                </Section>
              )}

              {brief.tone && (
                <Section label="Tone">
                  <Input value={brief.tone} name="tone" isTextarea readOnly className={Styles.input} />
                </Section>
              )}

              {brief.uniqueAngles.length > 0 && (
                <Section label="Unique angles">
                  <Input
                    value={brief.uniqueAngles.join('\n\n')}
                    name="unique-angles"
                    isTextarea
                    readOnly
                    className={Styles.input}
                  />
                </Section>
              )}

              {brief.contentHooks.length > 0 && (
                <Section label="Content hooks">
                  <Input
                    value={brief.contentHooks.join('\n\n')}
                    name="content-hooks"
                    isTextarea
                    readOnly
                    className={Styles.input}
                  />
                </Section>
              )}

              {brief.quotables.length > 0 && (
                <Section label="Quotables">
                  <Input
                    value={brief.quotables.join('\n\n')}
                    name="quotables"
                    isTextarea
                    readOnly
                    className={Styles.input}
                  />
                </Section>
              )}

              {brief.avoid && (
                <Section label="Avoid">
                  <Input value={brief.avoid} name="avoid" isTextarea readOnly className={Styles.input} />
                </Section>
              )}
            </>
          ) : (
            analysis.analysis && (
              <Section label="Analysis">
                <Input value={analysis.analysis} name="analysis" isTextarea readOnly className={Styles.input} />
              </Section>
            )
          )}
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton variant="tertiary" size="lg" onPress={closeModal}>
            Close
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
